import { useMutation } from '@apollo/client';
import { Mutations } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useAddBank = () => {
  const context = useAuthContext('payroll_employee:edit');
  const [addAccountItem] = useMutation(Mutations.addAccountItem, { context });
  const findStatus = accounts =>
    ((accounts || []).find(a => a.verification_status) || {})
      .verification_status;

  const mutation = (token, metadata, currency = 'US') => {
    return addAccountItem({
      variables: {
        input: {
          publicToken: token,
          linkSessionId: metadata.link_session_id,
          institutionName:
            (metadata.institution || {}).name || 'Custom Institution',
          institutionId: (metadata.institution || {}).institution_id,
          status: findStatus(metadata.accounts),
          currency,
        },
      },
    }).then(response => response.data.addAccountItem);
  };

  return mutation;
};

export default useAddBank;
